import React from 'react'
import "../Assets/Styles/Success.css"
import { Link } from 'react-router-dom'
const Success = () => {
  return (
    <>
    <div className="success-container">
        <img src="https://www.medibuddy.in/assets/gif/switch-profile-success.gif" alt="" />
        <Link to={"/email"}>
        <button>Back</button>
        </Link>
    </div>
    </>
  )
}

export default Success